<transition-group name="fade" tag="span"><slot></slot></transition-group>